import { useRepositoryMutation } from '@mews-commander/data-access';
import { DateTimeUtils, lt, showSuccessAlert, useDateTimeLocalizationInfo, useTimezone } from '@mews/framework';
import { SplitReservationFormValues } from './types';

export const useSplitReservationMutation = (reservationIds: string[]) => {
    const timezone = useTimezone();
    const localizationInfo = useDateTimeLocalizationInfo();

    return useRepositoryMutation('reservations', 'split', {
        transformParams: ({ date }: SplitReservationFormValues) => ({
            reservationIds,
            dateTimeUtc: DateTimeUtils.dateStringToDateTimeUtcString(date, localizationInfo, timezone),
        }),
        onSuccess: () => showSuccessAlert({ description: lt('ReservationSplitSuccessMessage') }),
    });
};
